import { bulkUploadAPI } from './endpoints';
import { actions } from 'store/Reducer/actions';

export const actionTypes = {
    BULK_UPLOAD_PENDING: "BULK_UPLOAD_PENDING",
    BULK_UPLOAD_RECEIVED: "BULK_UPLOAD_RECEIVED",
    BULK_UPLOAD_FAILED: "BULK_UPLOAD_FAILED",
};
const bulkUploadPending= () => ({
    type: actionTypes.BULK_UPLOAD_PENDING,
});
const bulkUploadReceived = (payload) => ({
    type: actionTypes.BULK_UPLOAD_RECEIVED,
    payload,
});
const bulkUploadFailed = (payload) => ({
    type: actionTypes.BULK_UPLOAD_FAILED,
    payload,
})

export const bulkUploaAction = (payload) => { 
    return async (dispatch) => {
        dispatch(bulkUploadPending());
        try {
            const response = await bulkUploadAPI(payload);                      
            if (response?.status === 200) {
                dispatch(bulkUploadReceived(response.data));
            }
        } catch (error) {    
            dispatch(bulkUploadFailed(error?.response?.data));        
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
}